export class GetStationsStation {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);

            this.hwAddress = json.HwAddress ?? json.hwAddress;
            this.name = json.Name ?? json.name;
            this.id = json.Id ?? json.id;

            // Lynx Cloud uses Title Case for some properties, so we need to delete the original properties to avoid confusion.
            // Lynx Drive uses camelCase.
            delete this['HwAddress'];
            delete this['Name'];
            delete this['Id'];
        }
    }

    hwAddress: string;
    id: number;
    name: string;
}
